import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import Select from '@tds/core-select';
import Button from '@tds/core-button';
import DimpleDivider from '@tds/core-dimple-divider';

import request from '../utils/request';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import ConfirmationBox from '../design/shared/ConfirmationBox';

const AddAssigneModal = ({ setSrtAssignee, setAssigneModal }) => {
  const localizedStrings = useLocalizedStringsContext();
  const staticLabels = localizedStrings.assigneeSRTModal;
  const {
    modalHeader,
    addAssigneeLabel,
    placeholder,
    addButton
  } = staticLabels;
  const [assigneList, setAssigneList] = useState([]);
  const [assigne, setAssigne] = useState(null);
  const [fieldError, setFieldError] = useState(false);

  const closeModal = () => {
    setAssigneModal(false);
  };

  useEffect(() => {
    // Check for the data chached in localstorage first
    if (localStorage.getItem('SRTAgentList')) {
      const agentList = localStorage.getItem('SRTAgentList');
      setAssigneList(JSON.parse(agentList));
      return;
    }
    // If data not found in cache then make the API call
    request.get('/srtGroupUsers').then(users => {
      const strAgentList = users.data.map(srtAgent => {
        return { text: srtAgent.name, value: JSON.stringify(srtAgent) };
      });

      setAssigneList(strAgentList);
      localStorage.setItem('SRTAgentList', JSON.stringify(strAgentList));
    });
  }, []);

  const setSelectedAssigne = () => {
    if (!assigne) {
      setFieldError(true);
      return;
    }
    setFieldError(false);
    setSrtAssignee(JSON.parse(assigne));
  };

  return (
    <ConfirmationBox header={modalHeader} open setOpen={closeModal}>
      <div style={{ marginTop: '2rem' }}>
        <Select
          label={addAssigneeLabel}
          placeholder={placeholder}
          options={assigneList}
          feedback={fieldError && 'error'}
          onChange={e => {
            setFieldError(false);
            setAssigne(e.target.value);
          }}
        />
        <DimpleDivider />
        <Button onClick={setSelectedAssigne}>{addButton}</Button>
      </div>
    </ConfirmationBox>
  );
};

AddAssigneModal.propTypes = {
  setAssigneModal: PropTypes.func.isRequired,
  setSrtAssignee: PropTypes.func.isRequired
};

export default AddAssigneModal;
